import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import { AccountProvider } from './Context/Account';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <AccountProvider>
    <BrowserRouter>
      <App/>
    </BrowserRouter>
    </AccountProvider>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();